import {
  Section,
  SectionParagraph as Subtitle,
  SectionTitle as Title,
  adjustContentVisibility,
} from '@/components/shared/Content';
import { Box } from '@lemonade-hq/cdk';
import type React from 'react';
import styled from 'styled-components';
import { AppsSection, type AppsSectionProps } from './AppsSection';

const StyledSection = styled(Section)`
  ${adjustContentVisibility}
`;

export interface ClaimsProps
  extends Pick<AppsSectionProps, 'arrowIndicators' | 'mobileImage' | 'phoneTwoConfig' | 'lerpValue'> {
  title: string;
  subtitle: string;
  desktopFrom?: number;
  desktopTo?: number;
}

export const Claims: React.FC<ClaimsProps> = ({
  title,
  subtitle,
  desktopFrom = 0.13,
  desktopTo = 0.6,
  ...restProps
}) => {
  return (
    <StyledSection pb={[0, 102]} pt={[45, 95, 95]}>
      <Title tabIndex={0}>{title}</Title>
      <Box my="20px">
        <Subtitle tabIndex={0}>{subtitle}</Subtitle>
      </Box>
      <AppsSection mobileFrom={0} mobileTo={0} desktopFrom={desktopFrom} desktopTo={desktopTo} {...restProps} />
    </StyledSection>
  );
};
